module.exports = __webpack_public_path__ + "static/media/ironman.45c1c3da.jpg";